import { off, on, popup } from '@telegram-apps/sdk-react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const usePhotoDeleteConfirm = (
  onConfirmDelete: (index: number) => void
) => {
  const { t } = useTranslation();
  const photoIndexRef = useRef<number | null>(null);

  useEffect(() => {
    const handler = (payload: { button_id?: string }) => {
      if (
        payload.button_id === 'delete_photo' &&
        photoIndexRef.current !== null
      ) {
        onConfirmDelete(photoIndexRef.current);
        photoIndexRef.current = null;
      }

      if (payload.button_id === 'cancel') {
        photoIndexRef.current = null;
      }
    };

    on('popup_closed', handler);

    return () => {
      off('popup_closed', handler);
    };
  }, [onConfirmDelete]);

  return async (index: number) => {
    photoIndexRef.current = index;

    await popup.show({
      title: t('delete_photo_title'),
      message: t('delete_photo_message'),
      buttons: [
        {
          id: 'delete_photo',
          type: 'destructive',
          text: t('delete_photo_action_title')
        },
        {
          id: 'cancel',
          type: 'default',
          text: t('delete_photo_cancel_title')
        }
      ]
    });
  };
};
